import React from 'react';
import { useTranslation } from 'react-i18next';
import Reveal from './Reveal';

interface PriceProps {
  value: number;
  highlight?: boolean;
}

const Price: React.FC<PriceProps> = ({ value, highlight }) => {
  const display = value.toFixed(2).replace('.', ',');
  return (
    <span className={`font-display text-2xl whitespace-nowrap flex-shrink-0 ${highlight ? 'text-luxury-gold' : 'text-luxury-black'}`}>
      {display}&nbsp;€
    </span>
  );
};

const PriceTable: React.FC = () => {
  const { t } = useTranslation();

  const adultRows = [
    { label: t('prices.weekdayLunch'), value: 19.9 },
    { label: t('prices.weekdayDinner'), value: 26.9 },
    { label: t('prices.saturdayLunch'), value: 27.9 },
    { label: t('prices.weekendDinner'), value: 28.9, highlight: true }
  ];

  const childRows = [
    { label: t('prices.child35'), value: 8.9 },
    { label: t('prices.child69'), value: 12.9 }
  ];

  return (
    <Reveal className="max-w-3xl mx-auto">
      <div className="bg-white rounded-lg shadow-xl overflow-hidden border border-luxury-gold/20">
        <div className="grid grid-cols-1 divide-y divide-luxury-gold/10">
          <div className="bg-luxury-gold/10 px-6 py-3">
            <span className="font-display text-luxury-gold text-sm uppercase tracking-[0.15em]">
              {t('menu.adultPrices')}
            </span>
          </div>
          {adultRows.map((row) => (
            <div
              key={row.label}
              className={`flex items-center justify-between gap-6 px-6 py-5 border-l-4 border-transparent hover:border-luxury-gold hover:bg-luxury-cream/40 transition-all duration-300 ${row.highlight ? 'bg-luxury-gold/5' : ''}`}
            >
              <span className="font-body font-semibold text-lg text-luxury-black leading-snug">{row.label}</span>
              <Price value={row.value} highlight={row.highlight} />
            </div>
          ))}

          <div className="bg-luxury-gold/10 px-6 py-3">
            <span className="font-display text-luxury-gold text-sm uppercase tracking-[0.15em]">
              {t('menu.childrenPrices')}
            </span>
          </div>
          {childRows.map((row) => (
            <div
              key={row.label}
              className="flex items-center justify-between gap-6 px-6 py-5 border-l-4 border-transparent hover:border-luxury-gold hover:bg-luxury-cream/40 transition-all duration-300"
            >
              <span className="font-body font-semibold text-lg text-luxury-black leading-snug">{row.label}</span>
              <Price value={row.value} />
            </div>
          ))}
          <div className="flex items-center justify-between gap-6 px-6 py-5 border-l-4 border-transparent hover:border-luxury-gold hover:bg-luxury-cream/40 transition-all duration-300">
            <span className="font-body font-semibold text-lg text-luxury-black leading-snug">{t('prices.childUnder3')}</span>
            <span className="font-display text-2xl text-luxury-black whitespace-nowrap flex-shrink-0">{t('prices.free')}</span>
          </div>
        </div>
      </div>

      <p className="text-center text-luxury-gray mt-6 text-sm font-body italic">
        {t('prices.disclaimer')}
      </p>
    </Reveal>
  );
};

export default PriceTable;
